module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.avulso) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
  }, [_c('ed-modal', {
    attrs: {
      "title": "INSERIR NOVO PROCEDIMENTO",
      "modal": _vm.showProcedimento,
      "onSave": _vm.inserirProcedimento,
      "isModal": false,
      "width": "50%"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Pesquisar procedimento",
      "items": _vm.bind.procedimentos,
      "loading": _vm.bind.loadingProcedimento,
      "clearable": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getProcedimento
    },
    model: {
      value: (_vm.bind.procedimento),
      callback: function($$v) {
        _vm.$set(_vm.bind, "procedimento", $$v)
      },
      expression: "bind.procedimento"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-group"
  }, [_vm._v("Informações da Consulta")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Data da Consulta",
      "maxDaysTomorrow": 1,
      "required": ""
    },
    model: {
      value: (_vm.formData.consulta.aso_dt),
      callback: function($$v) {
        _vm.$set(_vm.formData.consulta, "aso_dt", $$v)
      },
      expression: "formData.consulta.aso_dt"
    }
  }), _vm._v(" "), _c('ed-input-select-tipo', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Tipo de Consulta",
      "name": "id_tipo_aso",
      "tipo": "46",
      "required": ""
    },
    model: {
      value: (_vm.formData.consulta.id_tipo_aso),
      callback: function($$v) {
        _vm.$set(_vm.formData.consulta, "id_tipo_aso", $$v)
      },
      expression: "formData.consulta.id_tipo_aso"
    }
  }), _vm._v(" "), _c('ed-input-select-tipo', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Aptidão",
      "name": "id_tipo_aptidao",
      "tipo": "185",
      "required": ""
    },
    model: {
      value: (_vm.formData.consulta.aptidao),
      callback: function($$v) {
        _vm.$set(_vm.formData.consulta, "aptidao", $$v)
      },
      expression: "formData.consulta.aptidao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("Informações do Médico Examinador")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Nome do Médico",
      "name": "valor.medico.nome",
      "required": ""
    },
    model: {
      value: (_vm.formData.medico.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.medico, "nome", $$v)
      },
      expression: "formData.medico.nome"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "CRM do Médico",
      "name": "valor.medico.crm",
      "type": "number",
      "required": ""
    },
    model: {
      value: (_vm.formData.medico.crm),
      callback: function($$v) {
        _vm.$set(_vm.formData.medico, "crm", $$v)
      },
      expression: "formData.medico.crm"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Unidade Federativa do CRM",
      "name": "valor.medico.crm_uf",
      "items": _vm.parent.bind.estados,
      "required": ""
    },
    model: {
      value: (_vm.formData.medico.crm_uf),
      callback: function($$v) {
        _vm.$set(_vm.formData.medico, "crm_uf", $$v)
      },
      expression: "formData.medico.crm_uf"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("\n    Informações do Médico Coordenador do PCMSO\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Nome do Médico",
      "name": "valor.responsavel_pcmso.nome"
    },
    model: {
      value: (_vm.formData.responsavel_pcmso.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel_pcmso, "nome", $$v)
      },
      expression: "formData.responsavel_pcmso.nome"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "CRM do Médico",
      "name": "valor.responsavel_pcmso.crm",
      "type": "number"
    },
    model: {
      value: (_vm.formData.responsavel_pcmso.crm),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel_pcmso, "crm", $$v)
      },
      expression: "formData.responsavel_pcmso.crm"
    }
  }), _vm._v(" "), _c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4",
    attrs: {
      "label": "Unidade Federativa do CRM",
      "items": _vm.parent.bind.estados,
      "name": "valor.responsavel_pcmso.crm_uf"
    },
    model: {
      value: (_vm.formData.responsavel_pcmso.crm_uf),
      callback: function($$v) {
        _vm.$set(_vm.formData.responsavel_pcmso, "crm_uf", $$v)
      },
      expression: "formData.responsavel_pcmso.crm_uf"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-group mt-2"
  }, [_vm._v("Procedimentos - Tabela 27 do eSocial")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "success",
      "label": "Inserir Novo Exame",
      "title": "Inserir Novo Exame"
    },
    on: {
      "click": function($event) {
        _vm.showProcedimento = !_vm.showProcedimento
      }
    }
  }), _vm._v(" "), _c('b-table-simple', {
    staticClass: "col-12 table-v2 mt-1",
    attrs: {
      "id": "table-v0",
      "small": "",
      "outlined": "",
      "borered": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("CÓDIGO")]), _vm._v(" "), _c('b-th', [_vm._v("EXAME")]), _vm._v(" "), _c('b-th', [_vm._v("DATA DO EXAME")]), _vm._v(" "), _c('b-th', [_vm._v("RESULTADO")]), _vm._v(" "), _c('b-th', {
    attrs: {
      "width": "150"
    }
  })], 1)], 1), _vm._v(" "), _c('b-tbody', [(!_vm.formData.exames.length) ? _c('b-tr', [_c('b-td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v(" Nenhum exame cadastrado ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.exames), function(exame, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-td', [_vm._v("\n              " + _vm._s(exame.codigo) + "\n            ")]), _vm._v(" "), _c('b-td', [_vm._v("\n              " + _vm._s(exame.nome) + "\n            ")]), _vm._v(" "), _c('b-td', [_c('ed-input-date', {
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "maxDaysTomorrow": 1,
        "required": ""
      },
      model: {
        value: (exame.data),
        callback: function($$v) {
          _vm.$set(exame, "data", $$v)
        },
        expression: "exame.data"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-input-select', {
      staticStyle: {
        "with": "100%"
      },
      attrs: {
        "items": [{
            id: 1,
            nome: 'Normal'
          },
          {
            id: 2,
            nome: 'Alterado'
          },
          {
            id: 3,
            nome: 'Estável'
          },
          {
            id: 4,
            nome: 'Agravamento'
          } ],
        "required": ""
      },
      model: {
        value: (exame.resultado),
        callback: function($$v) {
          _vm.$set(exame, "resultado", $$v)
        },
        expression: "exame.resultado"
      }
    })], 1), _vm._v(" "), _c('b-td', [_c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "title": "Remover Novo Exame"
      },
      on: {
        "click": function($event) {
          return _vm.removerProcedimento(index)
        }
      }
    })], 1)], 1)
  })], 2)], 1)], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b00ed196"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/s2220.vue
// module id = 1485
// module chunks = 45